import { render, staticRenderFns } from "./SelectPartnerPage.vue?vue&type=template&id=18d11460&scoped=true"
import script from "./SelectPartnerPage.vue?vue&type=script&lang=js"
export * from "./SelectPartnerPage.vue?vue&type=script&lang=js"
import style0 from "./SelectPartnerPage.vue?vue&type=style&index=0&id=18d11460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d11460",
  null
  
)

export default component.exports